import { coerceBooleanProperty } from '@angular/cdk/coercion';

import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseLoadingService } from '@fuse/services/loading';

@Component({
    selector: 'fuse-loading-bar',
    templateUrl: './loading-bar.component.html',
    styleUrls: ['./loading-bar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    exportAs: 'fuseLoadingBar',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatProgressBarModule],
})
export class FuseLoadingBarComponent implements OnChanges {
    private _fuseLoadingService = inject(FuseLoadingService);

    readonly autoMode = input<boolean>(true);

    // Signals, not fields set from subscriptions: the interceptor flips `show$` synchronously
    // when a request starts while a view is being checked (the first loads after login), which
    // on a plain field raised NG0100 ExpressionChangedAfterItHasBeenChecked in dev mode. A
    // signal read by the template just schedules a refresh instead.
    readonly mode = toSignal(this._fuseLoadingService.mode$, { initialValue: 'indeterminate' as 'determinate' | 'indeterminate' });
    readonly progress = toSignal(this._fuseLoadingService.progress$, { initialValue: 0 });
    readonly show = toSignal(this._fuseLoadingService.show$, { initialValue: false });

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On changes
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        // Auto mode
        if ('autoMode' in changes) {
            // Set the auto mode in the service
            this._fuseLoadingService.setAutoMode(coerceBooleanProperty(changes.autoMode.currentValue));
        }
    }
}
